/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { ParcelTable, PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useParcels } from "../../store/useParcels";
import {
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevrons/chevron-down.svg";
import { yearsToShow } from "../../services/dateService";

function ParcelScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { getAllGroupedParcelsByCourier, allGroupedParcels } = useParcels();
  /** State */
  const storedYearRange =
    new Date(
      `${
        sessionStorage.getItem("parcelYearRange") ?? new Date().getFullYear()
      }-01-15`
    ) ?? new Date();
  const [yearRange, setYearRange] = useState(new Date(storedYearRange));
  const years = yearsToShow();

  const addParcel = () => navigate("/add-parcel");

  useEffect(() => {
    getAllGroupedParcelsByCourier(yearRange);
  }, [yearRange]);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Parcels
        </h1>
        <div className="flex flex-col sm:flex-row justify-end sm:items-center">
          <Menu>
            <MenuHandler>
              <button className="h-8 px-3 sm:ml-4 border rounded border-gray-border bg-white flex items-center justify-center font-satoshi font-medium text-gray-text text-sm">
                {yearRange.getFullYear()}
                <ChevronDown className="ml-2" />
              </button>
            </MenuHandler>
            <MenuList placeholder={undefined}>
              {years.map((year) => (
                <MenuItem
                  key={year}
                  onClick={() => {
                    setYearRange(new Date(`${year}-01-15`));
                    sessionStorage.setItem("parcelYearRange", String(year));
                  }}
                  className="font-satoshi text-base text-dark"
                  placeholder={undefined}
                >
                  {year}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>
          <PrimaryButton
            onClick={addParcel}
            size="sm"
            label="Add new Parcel"
            className="ml-3 !bg-droppie-oranje !border-droppie-oranje active:!bg-droppie-oranje-dark"
          />
        </div>
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl shadow-none drop-shadow-none">
        {!allGroupedParcels?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Parcel created yet.
          </p>
        ) : (
          <ParcelTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(ParcelScreen);
